import { defineComponent } from 'vue'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { AddItemForm, Values } from './add-item-form'

export const AddItemModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAddItemForm: AddItemForm,
    },
    props: ['movement', 'itemsIdsToExclude', 'noCloseImmediately', 'canChainAdd'],
    template: require('./add-item-modal.html'),
    data() {
        return {
            submitting: false,

            shouldChainAdd: false,

            initialValues: {
                identifier: null as any,
                location: null as any,
            } as Values,

            mounted: false,
        }
    },
    methods: {
        open() {
            (this.$refs.modal as any).show();
        },

        close() {
            (this.$refs.modal as any).hide();
        },

        onHide() {
            this.mounted = false;
        },

        onShow() {
            this.mounted = true;
        },

        onItemSelected(event) {
            this.$emit('item-selected', event)
            if (!this.noCloseImmediately && (!this.canChainAdd || !this.shouldChainAdd)) {
                (this.$refs.modal as any).hide();
            }
        },

        resetSearch() {
            (this.$refs.addItemForm as InstanceType<typeof AddItemForm>).resetSearch()
        },
    },
    watch: {
        mounted(value) {
            this.$emit('mounted', value);
        },
    },
})
